import { FC } from 'react';

import { ReferralLinksEditForm, ReferralLinksList } from '@/modules/Sites';

interface Props {
  isEditingList: boolean;
  referralId: string;
  siteId: string;
  handleSetEditingListMode: (is?: true) => void;
}

export const ReferralLinksOverviewView: FC<Props> = ({
  referralId,
  siteId,
  isEditingList,
  handleSetEditingListMode,
}) => {
  if (isEditingList) {
    return (
      <ReferralLinksEditForm
        referralId={ referralId }
        siteId={ siteId }
        handleSetEditingListMode={ handleSetEditingListMode }
      />
    );
  } else {
    return (
      <ReferralLinksList
        referralId={ referralId }
        siteId={ siteId }
        handleSetEditingListMode={ handleSetEditingListMode }
      />
    );
  }
};
